var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSodMarketShareStatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SOD_MarketShare_newStatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SOD_MarketShare_newStatic",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_rest",
    transform: "translate(0.985935, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9E8F6",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(63.485935, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6318719,0 C89.7501833,0 113.355239,23.6050554 113.355239,52.7233668 L60.6318719,52.7233668 L60.6318719,0 Z",
    id: "Combined-Shape",
    fill: "#4B76B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1394098,20.2246835 L86.0585943,22.5866904 C85.0463056,21.6587591 84.1746126,21.1807339 82.9936092,21.1807339 C81.643891,21.1807339 80.9127937,21.7149974 80.9127937,22.9803582 C80.9127937,25.6516754 88.3362437,25.4267224 88.3362437,30.797476 C88.3362437,33.4969124 86.8459299,35.5777279 83.9496596,36.1963488 L83.9496596,39.1207382 L81.2221041,39.1207382 L81.2221041,36.3088253 C79.5630755,36.1119914 77.5947364,35.380894 76.2731374,34.1717715 L78.0727616,31.3879777 C79.5068372,32.4565046 80.7440789,33.0188872 82.0937971,33.0188872 C83.6684683,33.0188872 84.3714465,32.3721472 84.3714465,31.0786673 C84.3714465,28.182397 76.9479965,28.2386353 76.9479965,23.1771921 C76.9479965,20.4215174 78.578906,18.5094167 81.2221041,17.9751532 L81.2221041,15.0788829 L83.9496596,15.0788829 L83.9496596,17.9189149 C85.7492838,18.1719871 87.0427638,19.0717992 88.1394098,20.2246835 Z",
    id: "$",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7233668,10.5446734 L52.7233668,63.2680402 L53.1359419,63.2680402 L90.2101374,100.342236 C80.6532825,110.004775 67.3874511,115.991407 52.7233668,115.991407 C23.6050554,115.991407 0,92.3863517 0,63.2680402 C0,34.1497287 23.6050554,10.5446734 52.7233668,10.5446734 Z",
    id: "Combined-Shape",
    fill: "#1A4480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8521391,63.2680402 L120.385021,63.2680402 C120.385021,77.875641 114.444419,91.09574 104.847341,100.644212 L67.6616541,63.4585252 L67.8521391,63.2680402 Z",
    id: "Combined-Shape",
    fill: "#1A4480"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodMarketShareStatic);
export default __webpack_public_path__ + "static/media/SOD_MarketShare_Static.58c4ce80cd0946d208000a3b2ab0a74c.svg";
export { ForwardRef as ReactComponent };